(function(){
  'use strict';

  var cfg=window.CoreOptimiseHealthConfig||{};
  var signedIn=!!cfg.signedIn;
  var customerId=String(cfg.customerId||'').trim();
  var localKey=customerId?'coreoptimise_health_'+customerId+'_v1':'coreoptimise_health_guest_v1';
  var syncEndpoint=String(cfg.syncEndpoint||'').trim();
  var providerBase=String(cfg.providerBase||syncEndpoint||'').trim();
  var dataVersion=1;
  var syncTimer=0,syncing=false,pendingPush=false,localRevision=0,confirmedRevision=0,pullConflict=false,syncError='';
  function syncStatus(){return{state:pullConflict?'review_required':syncing?'syncing':syncError?'unconfirmed':pendingPush?'pending':confirmedRevision&&confirmedRevision===localRevision?'confirmed':'unconfirmed',pending:pendingPush,accountConfirmed:!syncing&&!pendingPush&&!syncError&&!pullConflict&&confirmedRevision>0&&confirmedRevision===localRevision,error:syncError};}
  function syncEvent(){document.dispatchEvent(new CustomEvent('coreoptimise:health-sync-state',{detail:syncStatus()}));}
  function followUp(){if(pendingPush&&!pullConflict){clearTimeout(syncTimer);syncTimer=setTimeout(function(){syncTimer=0;return push();},650);}syncEvent();}

  var defaults={
    profile:{
      age:null,
      sexContext:'',
      diet:'',
      restrictions:'',
      primaryTraining:'',
      goals:[],
      notes:'',
      measurementSystem:'metric',
      measurementUnits:{height:'cm',weight:'kg',distance:'km'}
    },
    metrics:{},
    biomarkers:[],
    permissions:{
      body:true,
      training:true,
      recovery:true,
      nutrition:true,
      biomarkers:false,
      aiContext:false
    },
    sources:{
      manual:{id:'manual',name:'Manual entry',status:'available',connected:true,lastSync:null},
      garmin:{id:'garmin',name:'Garmin Connect',status:'not_connected',connected:false,lastSync:null},
      apple_health:{id:'apple_health',name:'Apple Health',status:'requires_app',connected:false,lastSync:null},
      health_connect:{id:'health_connect',name:'Health Connect',status:'requires_app',connected:false,lastSync:null},
      myfitnesspal:{id:'myfitnesspal',name:'MyFitnessPal',status:'approval_required',connected:false,lastSync:null}
    },
    activity:[],
    feedback:[],
    metricHistory:{},
    contextSnapshots:[],
    aiSummaries:[],
    sourcePreferences:{},
    metricConflicts:[],
    conclusionHistory:[],
    updatedAt:null
  };

  var metricDefs={
    height:{label:'Height',unit:'cm',category:'body'},
    weight:{label:'Weight',unit:'kg',category:'body'},
    bodyFat:{label:'Body fat',unit:'%',category:'body'},
    sessionsWeek:{label:'Training sessions / week',unit:'sessions',category:'training'},
    cardioMinutesWeek:{label:'Cardio / week',unit:'min',category:'training'},
    strengthSessionsWeek:{label:'Strength sessions / week',unit:'sessions',category:'training'},
    enduranceDistanceWeek:{label:'Endurance distance / week',unit:'km',category:'training'},
    stepsToday:{label:'Steps · today',unit:'steps',category:'training'},
    distanceToday:{label:'Distance · today',unit:'km',category:'training'},
    activeCaloriesToday:{label:'Active calories · today',unit:'kcal',category:'training'},
    vo2max:{label:'VO₂ max',unit:'ml/kg/min',category:'training'},
    restingHeartRate:{label:'Resting heart rate',unit:'bpm',category:'recovery'},
    heartRateAverageToday:{label:'Average heart rate · today',unit:'bpm',category:'recovery'},
    heartRateMinToday:{label:'Minimum heart rate · today',unit:'bpm',category:'recovery'},
    heartRateMaxToday:{label:'Maximum heart rate · today',unit:'bpm',category:'recovery'},
    hrv:{label:'HRV',unit:'ms',category:'recovery'},
    sleepLastNight:{label:'Last sleep',unit:'hours',category:'recovery'},
    sleepHours:{label:'7-night average sleep',unit:'hours',category:'recovery'},
    sleepConsistency:{label:'Sleep consistency',unit:'%',category:'recovery'},
    calories:{label:'Energy intake',unit:'kcal/day',category:'nutrition'},
    protein:{label:'Protein',unit:'g/day',category:'nutrition'},
    carbohydrate:{label:'Carbohydrate',unit:'g/day',category:'nutrition'},
    fat:{label:'Fat',unit:'g/day',category:'nutrition'},
    fibre:{label:'Fibre',unit:'g/day',category:'nutrition'},
    magnesiumDiet:{label:'Dietary magnesium',unit:'mg/day',category:'nutrition'},
    ironDiet:{label:'Dietary iron',unit:'mg/day',category:'nutrition'},
    b12Diet:{label:'Dietary vitamin B12',unit:'µg/day',category:'nutrition'},
    vitaminDDiet:{label:'Dietary vitamin D',unit:'µg/day',category:'nutrition'},
    steps24h:{label:'Steps · legacy 24h',unit:'steps',category:'training',legacy:true},
    distance24h:{label:'Distance · legacy 24h',unit:'km',category:'training',legacy:true},
    activeCalories24h:{label:'Active calories · legacy 24h',unit:'kcal',category:'training',legacy:true},
    heartRateAverage24h:{label:'Average heart rate · legacy 24h',unit:'bpm',category:'recovery',legacy:true},
    heartRateMin24h:{label:'Minimum heart rate · legacy 24h',unit:'bpm',category:'recovery',legacy:true},
    heartRateMax24h:{label:'Maximum heart rate · legacy 24h',unit:'bpm',category:'recovery',legacy:true}
  };

  function clone(v){return JSON.parse(JSON.stringify(v))}
  function now(){return new Date().toISOString()}
  function arr(v){return Array.isArray(v)?v:[]}
  function obj(v){return v&&typeof v==='object'&&!Array.isArray(v)?v:{}}
  function uid(){return 'coh_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,9)}
  function esc(v){return String(v==null?'':v)}
  function finite(v){if(v==null||typeof v==='boolean'||typeof v==='object'||String(v).trim()==='')return null;var n=Number(v);return Number.isFinite(n)?n:null}
  function canonicalMetric(key,value,unit){
    var n=finite(value),u=String(unit||metricDefs[key]?.unit||'').trim().toLowerCase();
    if(n==null)return{value:value,unit:String(unit||metricDefs[key]?.unit||'')};
    if(key==='height'){
      if(['m','meter','metre','meters','metres'].includes(u))n*=100;
      else if(['in','inch','inches'].includes(u))n*=2.54;
      else if(['ft','foot','feet'].includes(u))n*=30.48;
      return{value:Number(n.toFixed(3)),unit:'cm'}
    }
    if(key==='weight'){
      if(['g','gram','grams'].includes(u))n/=1000;
      else if(['lb','lbs','pound','pounds'].includes(u))n*=0.45359237;
      else if(['st','stone','stones'].includes(u))n*=6.35029318;
      return{value:Number(n.toFixed(3)),unit:'kg'}
    }
    if(key==='enduranceDistanceWeek'||key==='distanceToday'||key==='distance24h'){
      if(['mi','mile','miles'].includes(u))n*=1.609344;
      return{value:Number(n.toFixed(3)),unit:'km'}
    }
    return{value:n,unit:String(unit||metricDefs[key]?.unit||'')}
  }
  // Optional observation metadata; never infer legacy identity or copy provider credentials.
  function observationMeta(raw){
    var out={};raw=obj(raw);
    ['sourceAccountId','sourceRecordId','deviceId','recordKind','firstSeenAt','firstIngestedAt','revisedAt','timeZone','timezone','utcOffset','providerDay','timeBasis','algorithmVersion','methodologyVersion','methodVersion','observationVersion','completeness'].forEach(function(k){if(typeof raw[k]==='string'&&raw[k].trim())out[k]=raw[k];});
    ['revisionKnown','historyConflict'].forEach(function(k){if(typeof raw[k]==='boolean')out[k]=raw[k];});
    return out
  }
  function newObservationMeta(raw,stamp){
    return Object.assign({},observationMeta(raw),{observationVersion:'37.22.1',firstSeenAt:raw.firstSeenAt||stamp,revisionKnown:!!(raw.revisedAt||raw.updatedAt||raw.recordedAt)})
  }
  function historyIdentity(r){return JSON.stringify([r.sourceId||'',r.sourceAccountId||'',r.deviceId||'',r.algorithmVersion||'',r.methodologyVersion||r.methodVersion||'',r.timeZone||r.timezone||'',r.window||'',r.recordKind||'',r.unit||'',r.timeBasis||'']);}
  function observationRevision(r){var value=r.revisedAt||(r.revisionKnown!==false?r.updatedAt:''),t=Date.parse(value);return /T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value)&&Number.isFinite(t)?t:0}
  function normalize(data){
    data=obj(data);
    var out=clone(defaults);
    out.profile=Object.assign(out.profile,obj(data.profile));
    out.permissions=Object.assign(out.permissions,obj(data.permissions));
    out.sources=Object.assign(out.sources,obj(data.sources));
    out.metrics=obj(data.metrics);
    Object.keys(out.metrics).forEach(function(k){
      var m=obj(out.metrics[k]),canonical=canonicalMetric(k,m.value,m.unit);
      out.metrics[k]=Object.assign({},observationMeta(m),{
        value:m.value==null?'':canonical.value,
        unit:String(canonical.unit||metricDefs[k]?.unit||''),
        source:String(m.source||'Manual entry'),
        sourceId:String(m.sourceId||'manual'),
        updatedAt:String(m.updatedAt||m.recordedAt||now()),
        recordedAt:String(m.recordedAt||(!m.observationVersion?m.updatedAt:'')||''),
        syncedAt:String(m.syncedAt||''),
        periodStart:String(m.periodStart||''),
        periodEnd:String(m.periodEnd||''),
        dateKey:String(m.dateKey||''),
        partial:!!m.partial,
        window:String(m.window||''),
        note:String(m.note||'')
      })
    });
    out.biomarkers=arr(data.biomarkers).map(function(b){
      return{
        id:String(b.id||uid()),
        marker:String(b.marker||'').trim(),
        value:b.value==null?'':b.value,
        unit:String(b.unit||'').trim(),
        refLow:b.refLow==null?'':b.refLow,
        refHigh:b.refHigh==null?'':b.refHigh,
        measuredAt:String(b.measuredAt||'').trim(),
        source:String(b.source||'Manual result entry').trim(),
        note:String(b.note||'').trim(),
        savedAt:String(b.savedAt||now())
      }
    }).filter(function(b){return b.marker});
    out.activity=arr(data.activity).slice(0,100);
    out.feedback=arr(data.feedback).slice(0,100);
    out.metricHistory=obj(data.metricHistory);
    Object.keys(out.metricHistory).forEach(function(k){
      out.metricHistory[k]=arr(out.metricHistory[k]).slice(0,400).map(function(x){return Object.assign({},observationMeta(x),{
        value:x.value==null?'':x.value,unit:String(x.unit||metricDefs[k]?.unit||''),source:String(x.source||''),
        sourceId:String(x.sourceId||''),updatedAt:String(x.updatedAt||x.recordedAt||''),recordedAt:String(x.recordedAt||(!x.observationVersion?x.updatedAt:'')||''),
        syncedAt:String(x.syncedAt||''),periodStart:String(x.periodStart||''),periodEnd:String(x.periodEnd||''),
        dateKey:String(x.dateKey||''),partial:!!x.partial,window:String(x.window||'')
      })})
    });
    out.contextSnapshots=arr(data.contextSnapshots).slice(0,60);
    out.aiSummaries=arr(data.aiSummaries).slice(0,40);
    out.sourcePreferences=obj(data.sourcePreferences);
    out.metricConflicts=arr(data.metricConflicts).slice(0,60);
    out.conclusionHistory=arr(data.conclusionHistory).slice(0,120);
    ['steps24h','distance24h','activeCalories24h','heartRateAverage24h','heartRateMin24h','heartRateMax24h'].forEach(function(k){if(out.metrics[k]&&metricDefs[k]?.legacy)delete out.metrics[k]});
    out.updatedAt=String(data.updatedAt||'');
    return out
  }
  function readRaw(){
    try{return JSON.parse(localStorage.getItem(localKey)||'null')}catch(e){return null}
  }
  function read(){return normalize(readRaw()||defaults)}
  function emit(data){
    document.dispatchEvent(new CustomEvent('coreoptimise:health-updated',{detail:{data:data||read()}}))
  }
  function write(data,activity){
    var d=normalize(data);
    d.updatedAt=now();
    if(activity){
      d.activity.unshift({id:uid(),title:String(activity),savedAt:d.updatedAt});
      d.activity=d.activity.slice(0,100)
    }
    try{
      localStorage.setItem(localKey,JSON.stringify(d));
      emit(d);
      schedulePush();
      return true
    }catch(e){return false}
  }

  function setProfile(patch){
    var d=read();
    d.profile=Object.assign({},d.profile,obj(patch));
    d.profile.goals=arr(d.profile.goals).map(String);
    return write(d,'Health Context profile updated')
  }
  function setPermission(category,value){
    var d=read();
    if(Object.prototype.hasOwnProperty.call(d.permissions,category)){
      d.permissions[category]=!!value;
      return write(d,'Health data permission preference updated')
    }
    return false
  }
  function sameValue(a,b){
    var na=finite(a),nb=finite(b);
    if(Number.isFinite(na)&&Number.isFinite(nb))return Math.abs(na-nb)<0.000001;
    return String(a)==String(b)
  }
  function appendHistory(d,key,metric){
    d.metricHistory=obj(d.metricHistory);
    d.metricHistory[key]=arr(d.metricHistory[key]);
    var entry=Object.assign({},observationMeta(metric),{
      value:metric.value,unit:metric.unit,source:metric.source,sourceId:metric.sourceId,
      updatedAt:metric.updatedAt||metric.recordedAt||now(),recordedAt:metric.recordedAt||(!metric.observationVersion?metric.updatedAt:'')||'',
      syncedAt:metric.syncedAt||'',periodStart:metric.periodStart||'',periodEnd:metric.periodEnd||'',
      dateKey:metric.dateKey||'',partial:!!metric.partial,window:metric.window||''
    });
    if(entry.dateKey){
      var idx=d.metricHistory[key].findIndex(function(x){return String(x.dateKey||'')===String(entry.dateKey)&&historyIdentity(x)===historyIdentity(entry)});
      if(idx>-1){
        var previous=d.metricHistory[key][idx];entry.firstSeenAt=previous.firstSeenAt||entry.firstSeenAt;metric.firstSeenAt=entry.firstSeenAt;var oldRevision=observationRevision(previous),newRevision=observationRevision(entry);
        if(newRevision<oldRevision)return;
        if(newRevision===oldRevision&&!sameValue(previous.value,entry.value)){
          entry.historyConflict=true;
          // Preserve both unresolved values, without adding duplicates on repeated sync.
          if(!d.metricHistory[key].some(function(x){return x.dateKey===entry.dateKey&&historyIdentity(x)===historyIdentity(entry)&&sameValue(x.value,entry.value)&&observationRevision(x)===newRevision;}))d.metricHistory[key].push(entry);
          d.metricHistory[key][idx].historyConflict=true;
        }else{
          if(newRevision===oldRevision&&!previous.partial&&entry.partial)return;
          entry.firstSeenAt=previous.firstSeenAt||entry.firstSeenAt;
          if(newRevision>oldRevision){entry.historyConflict=false;d.metricHistory[key]=d.metricHistory[key].filter(function(x,i){return i===idx||x.dateKey!==entry.dateKey||historyIdentity(x)!==historyIdentity(entry);});}
          d.metricHistory[key][d.metricHistory[key].indexOf(previous)]=Object.assign({},previous,entry);
        }
      }else d.metricHistory[key].push(entry);
      d.metricHistory[key].sort(function(a,b){var da=String(a.dateKey||''),db=String(b.dateKey||'');if(da&&db&&da!==db)return db.localeCompare(da);return String(b.updatedAt||'').localeCompare(String(a.updatedAt||''))})
    }else{
      var latest=d.metricHistory[key][0];
      if(!latest || !sameValue(latest.value,entry.value) || historyIdentity(latest)!==historyIdentity(entry))d.metricHistory[key].unshift(entry);else d.metricHistory[key][0]=Object.assign({},latest,entry)
    }
    d.metricHistory[key]=d.metricHistory[key].slice(0,400)
  }

  function createMetricConflict(d,key,current,incoming){
    d.metricConflicts=arr(d.metricConflicts);
    var existing=d.metricConflicts.find(function(c){
      return c.key===key && c.status!=='resolved' &&
        String(c.current?.sourceId||'')===String(current?.sourceId||'') &&
        String(c.incoming?.sourceId||'')===String(incoming?.sourceId||'') &&
        sameValue(c.incoming?.value,incoming?.value)
    });
    if(existing)return existing;
    var conflict={
      id:uid(),key:key,label:metricDefs[key]?.label||key,status:'open',savedAt:now(),
      current:clone(current||{}),incoming:clone(incoming||{})
    };
    d.metricConflicts.unshift(conflict);
    d.metricConflicts=d.metricConflicts.slice(0,60);
    return conflict
  }
  function preferredSourceFor(key){return String(read().sourcePreferences?.[key]||'')}
  function setPreferredSource(key,sourceId){
    if(!metricDefs[key])return false;
    var d=read();
    d.sourcePreferences[key]=String(sourceId||'');
    return write(d,(metricDefs[key]?.label||key)+' preferred source updated')
  }
  function resolveMetricConflict(id,choice){
    var d=read(),c=d.metricConflicts.find(function(x){return x.id===id});
    if(!c)return false;
    if(choice==='incoming'){
      d.metrics[c.key]=clone(c.incoming);
      appendHistory(d,c.key,d.metrics[c.key]);
      d.sourcePreferences[c.key]=String(c.incoming.sourceId||'')
    }else if(choice==='current'){
      if(c.current?.sourceId)d.sourcePreferences[c.key]=String(c.current.sourceId)
    }
    c.status='resolved';c.resolvedAt=now();c.resolution=choice;
    d.metricConflicts=d.metricConflicts.map(function(x){return x.id===id?c:x});
    return write(d,(metricDefs[c.key]?.label||c.key)+' source conflict resolved')
  }
  function setMetric(key,value,meta){
    if(!metricDefs[key])return false;
    var d=read(),def=metricDefs[key],m=obj(meta),stamp=now(),canonical=canonicalMetric(key,value,m.unit||def.unit||'');
    var incoming=Object.assign({},newObservationMeta(m,stamp),{
      value:canonical.value,
      unit:String(canonical.unit||def.unit||''),
      source:String(m.source||'Manual entry'),
      sourceId:String(m.sourceId||'manual'),
      updatedAt:String(m.updatedAt||m.recordedAt||stamp),
      recordedAt:String(m.recordedAt||''),
      syncedAt:String(m.syncedAt||''),periodStart:String(m.periodStart||''),periodEnd:String(m.periodEnd||''),
      dateKey:String(m.dateKey||''),partial:!!m.partial,
      window:String(m.window||''),
      note:String(m.note||'')
    });
    if(incoming.sourceId==='manual'){incoming.revisionKnown=true;incoming.recordedAt=incoming.recordedAt||stamp;}
    var current=d.metrics[key],preferred=String(d.sourcePreferences?.[key]||'');
    if(current && current.value!=='' && current.sourceId!==incoming.sourceId && !sameValue(current.value,incoming.value)){
      if(preferred && incoming.sourceId!==preferred){
        createMetricConflict(d,key,current,incoming);
        return write(d,def.label+' received a value from a non-preferred source')
      }
      if(!preferred){
        createMetricConflict(d,key,current,incoming);
        return write(d,def.label+' has two source values to review')
      }
    }
    appendHistory(d,key,incoming);
    if(!current||historyIdentity(current)!==historyIdentity(incoming)||!(current.dateKey&&incoming.dateKey&&current.dateKey>incoming.dateKey)&&observationRevision(incoming)>=observationRevision(current))d.metrics[key]=incoming;
    if(!d.sourcePreferences[key])d.sourcePreferences[key]=incoming.sourceId;
    return write(d,def.label+' updated')
  }
  function setMetrics(metrics,source){
    var d=read(),stamp=now(),src=obj(source),changed=0,conflicts=0;
    Object.keys(obj(metrics)).forEach(function(key){
      if(!metricDefs[key])return;
      var incomingRaw=obj(metrics[key]),def=metricDefs[key];
      if(!d.permissions[def.category])return;
      var canonical=canonicalMetric(key,incomingRaw.value,incomingRaw.unit||def.unit||'');
      var incoming=Object.assign({},newObservationMeta(Object.assign({},observationMeta(src),incomingRaw),stamp),{
        value:canonical.value,
        unit:String(canonical.unit||def.unit||''),
        source:String(incomingRaw.source||src.name||'Connected source'),
        sourceId:String(incomingRaw.sourceId||src.id||'connected'),
        updatedAt:String(incomingRaw.updatedAt||incomingRaw.recordedAt||stamp),
        recordedAt:String(incomingRaw.recordedAt||''),
        syncedAt:String(incomingRaw.syncedAt||src.syncedAt||stamp),periodStart:String(incomingRaw.periodStart||''),periodEnd:String(incomingRaw.periodEnd||''),
        dateKey:String(incomingRaw.dateKey||''),partial:!!incomingRaw.partial,
        window:String(incomingRaw.window||''),
        note:String(incomingRaw.note||'')
      });
      var current=d.metrics[key],preferred=String(d.sourcePreferences?.[key]||'');
      if(current && current.value!=='' && current.sourceId!==incoming.sourceId && !sameValue(current.value,incoming.value)){
        if((preferred && incoming.sourceId!==preferred)||!preferred){
          createMetricConflict(d,key,current,incoming);conflicts++;return
        }
      }
      appendHistory(d,key,incoming);
      if(!current||historyIdentity(current)!==historyIdentity(incoming)||!(current.dateKey&&incoming.dateKey&&current.dateKey>incoming.dateKey)&&observationRevision(incoming)>=observationRevision(current))d.metrics[key]=incoming;
      if(!d.sourcePreferences[key])d.sourcePreferences[key]=incoming.sourceId;
      changed++
    });
    if(src.id){
      d.sources[src.id]=Object.assign({},d.sources[src.id]||{id:src.id,name:src.name||src.id},{
        connected:true,status:'connected',lastSync:stamp
      })
    }
    return write(d,(src.name||'Connected source')+' synced · '+changed+' updated'+(conflicts?' · '+conflicts+' conflict'+(conflicts===1?'':'s')+' to review':''))
  }
  function removeMetric(key){
    var d=read();delete d.metrics[key];delete d.metricHistory[key];delete d.sourcePreferences[key];
    d.metricConflicts=d.metricConflicts.filter(function(c){return c.key!==key});
    return write(d,(metricDefs[key]?.label||key)+' removed')
  }
  function addBiomarker(b){
    if(!read().permissions.biomarkers)return{ok:false,error:'Biomarker storage is disabled in Health Context permissions.'};
    var d=read(),x=obj(b);
    var item={
      id:uid(),
      marker:String(x.marker||'').trim(),
      value:x.value==null?'':x.value,
      unit:String(x.unit||'').trim(),
      refLow:x.refLow==null?'':x.refLow,
      refHigh:x.refHigh==null?'':x.refHigh,
      measuredAt:String(x.measuredAt||'').trim(),
      source:String(x.source||'Manual result entry').trim(),
      note:String(x.note||'').trim(),
      savedAt:now()
    };
    if(!item.marker||item.value==='')return{ok:false,error:'Marker and value are required.'};
    d.biomarkers.unshift(item);
    if(!write(d,'Blood result added · '+item.marker))return{ok:false,localSaved:false,error:'The blood result could not be saved on this device. Your entries are unchanged; retry when storage is available.'};
    return{ok:true,localSaved:true,accountConfirmed:false,item:item}
  }
  function removeBiomarker(id){
    var d=read();d.biomarkers=d.biomarkers.filter(function(x){return x.id!==id});return write(d,'Blood result removed')
  }
  function clearCategory(category){
    var d=read();
    Object.keys(d.metrics).forEach(function(k){if(metricDefs[k]?.category===category){delete d.metrics[k];delete d.metricHistory[k];delete d.sourcePreferences[k]}});
    d.metricConflicts=d.metricConflicts.filter(function(c){return metricDefs[c.key]?.category!==category});
    if(category==='biomarkers')d.biomarkers=[];
    return write(d,'Health Context '+category+' data cleared')
  }
  function disconnectSource(id){
    var d=read();
    Object.keys(d.metrics).forEach(function(k){
      if(d.metrics[k]?.sourceId===id)delete d.metrics[k];
      d.metricHistory[k]=arr(d.metricHistory[k]).filter(function(x){return x.sourceId!==id});
      if(d.sourcePreferences[k]===id)delete d.sourcePreferences[k]
    });
    d.metricConflicts=d.metricConflicts.filter(function(c){return c.current?.sourceId!==id&&c.incoming?.sourceId!==id});
    if(d.sources[id])d.sources[id]=Object.assign({},d.sources[id],{connected:false,status:'disconnected',lastSync:null});
    var saved=write(d,(d.sources[id]?.name||id)+' disconnected and imported data removed');

    if(syncEndpoint&&signedIn){
      var url='',sep=syncEndpoint.indexOf('?')>-1?'&':'?';
      if(id==='apple_health'||id==='health_connect')url=syncEndpoint+sep+'scope=mobile&action=revoke_source&source='+encodeURIComponent(id);
      if(id==='garmin'||id==='myfitnesspal')url=syncEndpoint+sep+'scope=provider&provider='+encodeURIComponent(id)+'&action=disconnect';
      if(url)fetch(url,{method:'POST',credentials:'include',headers:{Accept:'application/json'}}).catch(function(){})
    }
    return saved
  }
  function clearAllHealthData(){
    var reset=clone(defaults);
    reset.updatedAt=now();
    try{
      localStorage.setItem(localKey,JSON.stringify(reset));
      emit(reset);schedulePush();return true
    }catch(e){return false}
  }

  function stackData(){
    return window.CoreOptimiseAccount?.get?.().stack||[]
  }
  function stackHas(regex){
    return stackData().some(function(i){
      return arr(i.actives).concat(arr(i.forms)).some(function(x){return regex.test(String(x))})
    })
  }
  function biomarkerMatch(regex){
    return read().biomarkers.find(function(b){return regex.test(b.marker)})
  }
  function biomarkerStatus(b){
    if(!b)return null;
    var v=Number(b.value),lo=b.refLow===''?null:Number(b.refLow),hi=b.refHigh===''?null:Number(b.refHigh);
    if(!Number.isFinite(v))return'unknown';
    if(lo!==null&&Number.isFinite(lo)&&v<lo)return'below_entered_range';
    if(hi!==null&&Number.isFinite(hi)&&v>hi)return'above_entered_range';
    if((lo!==null&&Number.isFinite(lo))||(hi!==null&&Number.isFinite(hi)))return'within_entered_range';
    return'no_range'
  }
  function contextSummary(){
    var d=read(),out=[],diet=String(d.profile.diet||'').toLowerCase(),m=d.metrics;
    var b12Blood=biomarkerMatch(/b12|cobalamin/i);

    if(/vegan/.test(diet)){
      if(stackHas(/b12|cobalamin/i)){
        out.push({
          id:'vegan-b12-covered',status:'Likely already covered',
          title:'Vitamin B12 appears in your current Stack',
          text:'Your vegan dietary pattern makes vitamin B12 nutritionally relevant, and at least one saved Stack product declares B12. This does not assess whether the total amount is personally appropriate.',
          why:['Diet pattern','Current Stack'],
          confidence:b12Blood?'High context confidence':'Medium context confidence'
        })
      }else{
        out.push({
          id:'vegan-b12-review',status:b12Blood&&biomarkerStatus(b12Blood)==='within_entered_range'?'More information needed':'Worth reviewing',
          title:'Vitamin B12 is relevant to your recorded diet pattern',
          text:b12Blood&&biomarkerStatus(b12Blood)==='within_entered_range'
            ?'Your recorded B12 result sits within the laboratory range you entered. Your vegan dietary pattern remains relevant context, but this record alone does not establish a need for supplementation.'
            :'No B12-containing product is currently identified in My Stack. Dietary intake and/or a current clinician-interpreted blood result would provide stronger context.',
          why:['Diet pattern',b12Blood?'Blood result':'No B12 identified in Stack'],
          confidence:b12Blood?'High context confidence':'Medium context confidence'
        })
      }
    }

    if(m.fibre&&Number(m.fibre.value)<30){
      out.push({
        id:'fibre-context',status:'Worth reviewing',
        title:'Tracked fibre intake is below the 30 g/day adult reference used here',
        text:'Your saved nutrition average is '+m.fibre.value+' '+(m.fibre.unit||'g/day')+'. This is a food-intake context flag rather than a supplement recommendation.',
        why:['Tracked nutrition','7-day or supplied average'],
        confidence:m.fibre.window?'High data confidence':'Medium data confidence'
      })
    }

    if(m.sleepHours&&Number(m.sleepHours.value)<7){
      out.push({
        id:'sleep-context',status:'Worth reviewing',
        title:'Recovery context may deserve attention',
        text:'Your recorded average sleep is '+m.sleepHours.value+' hours. Intelligence will treat this as recovery context rather than interpreting it as a nutrient deficiency.',
        why:['Recovery data'],
        confidence:m.sleepHours.sourceId==='manual'?'Medium data confidence':'High data confidence'
      })
    }

    d.biomarkers.forEach(function(b){
      var st=biomarkerStatus(b);
      if(st==='below_entered_range'||st==='above_entered_range'){
        out.push({
          id:'blood-'+b.id,status:'Worth reviewing',
          title:b.marker+' is outside the laboratory range you entered',
          text:'The result is recorded as '+b.value+' '+b.unit+'. This is not a diagnosis and should be interpreted with the clinician/laboratory that ordered or reviewed the test before changing supplementation.',
          why:['Entered blood result','Entered laboratory reference range'],
          confidence:'High data confidence · user-entered result'
        })
      }else if(st==='within_entered_range'){
        out.push({
          id:'blood-inrange-'+b.id,status:'More information needed',
          title:b.marker+' is recorded within the entered laboratory range',
          text:'The current result is within the range you supplied. That does not, by itself, establish whether a supplement is needed or unnecessary.',
          why:['Entered blood result'],
          confidence:'High data confidence · user-entered result'
        })
      }
    });

    if(!out.length){
      out.push({
        id:'build-context',status:'More information needed',
        title:'Add more Health Context to strengthen Intelligence',
        text:'Diet, tracked nutrition, recovery data, wearable metrics and optional blood results can provide context around your supplement routine without turning wearable data into a diagnosis.',
        why:['Current Health Context coverage'],
        confidence:'Building'
      })
    }
    return out.slice(0,8)
  }

  function trend(key,days){
    days=Number(days)||30;
    var hist=arr(read().metricHistory?.[key]).filter(function(x){
      var t=new Date(x.updatedAt||0).getTime();
      return t && Date.now()-t<=days*86400000 && Number.isFinite(Number(x.value))
    });
    if(hist.length<2)return{status:'Insufficient data',delta:null,from:null,to:hist[0]?.value??null,points:hist.length};
    var newest=Number(hist[0].value),oldest=Number(hist[hist.length-1].value),delta=newest-oldest;
    var tolerance=Math.max(Math.abs(oldest)*0.015,0.01);
    var status=Math.abs(delta)<=tolerance?'Stable':delta>0?'Increasing':'Decreasing';
    if(hist.length>=4){
      var diffs=[];
      for(var i=1;i<hist.length;i++)diffs.push(Math.abs(Number(hist[i-1].value)-Number(hist[i].value)));
      var avg=diffs.reduce(function(a,b){return a+b},0)/diffs.length;
      if(avg>Math.max(Math.abs(oldest)*0.08,1) && Math.abs(delta)<avg)status='Variable'
    }
    return{status:status,delta:Number(delta.toFixed(2)),from:oldest,to:newest,points:hist.length,days:days}
  }
  function trends(keys,days){
    var out={};arr(keys).forEach(function(k){out[k]=trend(k,days)});return out
  }
  function snapshotPayload(){
    var d=read();
    return{
      profile:clone(d.profile),metrics:clone(d.metrics),biomarkers:clone(d.biomarkers),
      permissions:clone(d.permissions),sourcePreferences:clone(d.sourcePreferences),
      stackSnapshot:window.CoreOptimiseAccount?.stackSnapshot?.()||null,
      contextSummary:contextSummary(),savedAt:now()
    }
  }
  function saveContextSnapshot(label){
    var d=read(),snap={id:uid(),title:String(label||'Health Context Snapshot'),savedAt:now(),payload:snapshotPayload()};
    d.contextSnapshots.unshift(snap);d.contextSnapshots=d.contextSnapshots.slice(0,60);
    write(d,'Health Context snapshot saved');return snap
  }
  function compareContextSnapshots(aId,bId){
    var d=read(),a=d.contextSnapshots.find(function(x){return x.id===aId}),b=bId?d.contextSnapshots.find(function(x){return x.id===bId}):null;
    if(!a)return null;
    var current=b?.payload||snapshotPayload(),old=a.payload||{},changes=[];
    Object.keys(metricDefs).forEach(function(k){
      var av=old.metrics?.[k]?.value,bv=current.metrics?.[k]?.value;
      if(av!==undefined&&bv!==undefined&&!sameValue(av,bv))changes.push({key:k,label:metricDefs[k].label,from:av,to:bv,unit:current.metrics?.[k]?.unit||old.metrics?.[k]?.unit||''})
    });
    ['diet','primaryTraining'].forEach(function(k){
      var av=old.profile?.[k],bv=current.profile?.[k];if(String(av||'')!==String(bv||''))changes.push({key:k,label:k==='diet'?'Diet pattern':'Primary training',from:av||'Not added',to:bv||'Not added',unit:''})
    });
    return{from:a,to:b||{title:'Current Health Context',savedAt:now()},changes:changes}
  }
  function candidateContext(candidate){
    candidate=obj(candidate);var d=read(),actives=arr(candidate.actives).map(String),stack=stackData(),existing=[];
    actives.forEach(function(a){
      var rx=new RegExp(String(a).replace(/[.*+?^${}()|[\]\\]/g,'\\$&'),'i');
      if(stack.some(function(i){return arr(i.actives).some(function(x){return rx.test(String(x))})}))existing.push(a)
    });
    var flags=contextSummary().filter(function(x){return x.status!=='Likely already covered'}).slice(0,4);
    var status=existing.length>=Math.max(1,Math.ceil(actives.length*.6))?'Mostly duplicates current routine':flags.length?'More information needed':'Adds new routine context';
    return{
      status:status,
      existingActives:existing,
      newActives:actives.filter(function(a){return !existing.includes(a)}),
      healthFlags:flags,
      note:'This checks saved Stack overlap and Health Context only. It does not establish that a supplement is needed, suitable or medically appropriate.'
    }
  }
  function aiEndpoint(action){
    if(!syncEndpoint)return'';
    var sep=syncEndpoint.indexOf('?')>-1?'&':'?';
    return syncEndpoint+sep+'scope=ai&action='+encodeURIComponent(action||'context_summary')
  }
  async function requestAISummary(){
    var current=read();
    if(!current.permissions?.aiContext)return{ok:false,error:'Enable AI Context Intelligence permission in Connections & privacy first.'};
    if(!signedIn||!syncEndpoint)return{ok:false,error:'Secure cloud sync must be enabled before server-side Context Intelligence can run.'};
    try{
      var r=await fetch(aiEndpoint('context_summary'),{method:'POST',credentials:'include',headers:{Accept:'application/json','Content-Type':'application/json'},body:'{}'});
      var body=await r.json();
      if(!r.ok||!body?.ok)return{ok:false,error:body?.error||('AI summary failed '+r.status)};
      var d=read(),item={
        id:uid(),title:'CoreOptimise® Context Intelligence',savedAt:now(),
        model:String(body.model||''),summary:body.summary,contextFingerprint:String(body.contextFingerprint||'')
      };
      var previous=d.aiSummaries[0];
      if(previous?.summary){
        item.changeFromPrevious={
          quickChanged:JSON.stringify(previous.summary.quick_summary)!==JSON.stringify(item.summary.quick_summary),
          previousId:previous.id
        }
      }
      d.aiSummaries.unshift(item);d.aiSummaries=d.aiSummaries.slice(0,40);
      d.conclusionHistory.unshift({id:uid(),savedAt:item.savedAt,summaryId:item.id,insights:clone(item.summary.insights||[])});
      d.conclusionHistory=d.conclusionHistory.slice(0,120);
      write(d,'Context Intelligence summary generated');
      return{ok:true,item:item}
    }catch(e){return{ok:false,error:String(e.message||e)}}
  }
  function latestAISummary(){return read().aiSummaries[0]||null}
  function compareAISummaries(currentId,previousId){
    var d=read(),current=d.aiSummaries.find(function(x){return x.id===currentId})||d.aiSummaries[0],previous=d.aiSummaries.find(function(x){return x.id===previousId})||d.aiSummaries[1];
    if(!current||!previous)return null;
    var oldMap={},newMap={};
    arr(previous.summary?.insights).forEach(function(i){oldMap[String(i.key||i.title||'')]=i});
    arr(current.summary?.insights).forEach(function(i){newMap[String(i.key||i.title||'')]=i});
    var changed=[];
    Object.keys(newMap).forEach(function(k){
      if(!oldMap[k])changed.push({type:'new',title:newMap[k].title||k,detail:'New conclusion'});
      else if(JSON.stringify(oldMap[k])!==JSON.stringify(newMap[k]))changed.push({type:'changed',title:newMap[k].title||k,detail:newMap[k].change_reason||'Supporting context or conclusion changed'})
    });
    Object.keys(oldMap).forEach(function(k){if(!newMap[k])changed.push({type:'removed',title:oldMap[k].title||k,detail:'No longer highlighted in the latest summary'})});
    return{current:current,previous:previous,changes:changed}
  }
  function coverage(){
    var d=read();
    var groups={
      body:['height','weight','bodyFat'],
      training:['sessionsWeek','cardioMinutesWeek','strengthSessionsWeek','enduranceDistanceWeek','vo2max'],
      recovery:['restingHeartRate','hrv','sleepHours','sleepConsistency'],
      nutrition:['calories','protein','carbohydrate','fat','fibre','magnesiumDiet','ironDiet','b12Diet','vitaminDDiet']
    },result={};
    Object.keys(groups).forEach(function(k){
      var total=groups[k].length,filled=groups[k].filter(function(x){return d.metrics[x]&&d.metrics[x].value!==''}).length;
      result[k]={filled:filled,total:total}
    });
    result.profile={
      filled:['diet','primaryTraining'].filter(function(k){return String(d.profile[k]||'').trim()}).length+(arr(d.profile.goals).length?1:0),
      total:3
    };
    result.biomarkers={filled:d.biomarkers.length?1:0,total:1};
    return result
  }
  function sourceCount(){
    var d=read();return Object.values(d.sources).filter(function(s){return s.connected&&s.id!=='manual'}).length
  }
  function latestUpdated(){
    var d=read(),dates=[d.updatedAt];
    Object.values(d.metrics).forEach(function(m){dates.push(m.updatedAt)});
    d.biomarkers.forEach(function(b){dates.push(b.measuredAt||b.savedAt)});
    return dates.filter(Boolean).sort().reverse()[0]||null
  }
  function exportHealthContext(){
    var d=read(),payload={
      product:'My CoreOptimise® Health Context',
      exportedAt:now(),
      privacy:'Contains health and fitness context selected or entered by the account holder. Does not contain Shopify order/payment data.',
      healthContext:d,
      contextSummary:contextSummary()
    };
    var blob=new Blob([JSON.stringify(payload,null,2)],{type:'application/json'}),url=URL.createObjectURL(blob),a=document.createElement('a');
    a.href=url;a.download='my-coreoptimise-health-context-'+new Date().toISOString().slice(0,10)+'.json';
    document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url)},1000);
    return true
  }
  function feedback(useful,context){
    var d=read();
    d.feedback.unshift({id:uid(),useful:!!useful,context:obj(context),savedAt:now()});
    d.feedback=d.feedback.slice(0,100);
    return write(d)
  }

  async function pull(){
    if(!syncEndpoint||!signedIn||syncing||pendingPush||localRevision>confirmedRevision||pullConflict)return false;
    syncing=true;var startedRevision=localRevision;syncEvent();
    try{
      var sep=syncEndpoint.indexOf('?')>-1?'&':'?';
      var r=await fetch(syncEndpoint+sep+'scope=health',{credentials:'include',headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error('Health sync pull '+r.status);
      var body=await r.json(),remote=body?.data||body;
      if(localRevision!==startedRevision){pullConflict=true;syncError='Saved on this device, but account data arrived during your edit. Account sync is paused for review; keep this page open and preserve your entries.';clearTimeout(syncTimer);syncTimer=0;return false;}
      if(remote&&typeof remote==='object'){
        var local=read(),merged=normalize(Object.assign({},local,remote,{
          profile:Object.assign({},local.profile,obj(remote.profile)),
          metrics:Object.assign({},local.metrics,obj(remote.metrics)),
          permissions:Object.assign({},local.permissions,obj(remote.permissions)),
          sources:Object.assign({},local.sources,obj(remote.sources)),
          biomarkers:arr(remote.biomarkers).length?remote.biomarkers:local.biomarkers,
          metricHistory:Object.assign({},local.metricHistory,obj(remote.metricHistory)),
          contextSnapshots:arr(remote.contextSnapshots).length?remote.contextSnapshots:local.contextSnapshots,
          aiSummaries:arr(remote.aiSummaries).length?remote.aiSummaries:local.aiSummaries,
          sourcePreferences:Object.assign({},local.sourcePreferences,obj(remote.sourcePreferences)),
          metricConflicts:arr(remote.metricConflicts).length?remote.metricConflicts:local.metricConflicts,
          conclusionHistory:arr(remote.conclusionHistory).length?remote.conclusionHistory:local.conclusionHistory
        }));
        localStorage.setItem(localKey,JSON.stringify(merged));emit(merged)
      }
      return true
    }catch(e){
      console.warn('CoreOptimise Health sync pull failed',e);
      return false
    }finally{syncing=false;followUp()}
  }
  async function push(){
    if(!syncEndpoint||!signedIn||pullConflict)return false;
    if(syncing){pendingPush=true;syncEvent();return false;}
    syncing=true;pendingPush=false;clearTimeout(syncTimer);syncTimer=0;var submittedRevision=localRevision;syncEvent();
    try{
      var sep=syncEndpoint.indexOf('?')>-1?'&':'?';
      var r=await fetch(syncEndpoint+sep+'scope=health',{method:'POST',credentials:'include',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({data:read()})});
      if(!r.ok)throw new Error('Health sync push '+r.status);
      var receipt=await r.json();if(receipt?.ok!==true)throw new Error('Health account save was not acknowledged');
      confirmedRevision=submittedRevision;syncError='';
      return submittedRevision===localRevision
    }catch(e){
      syncError='Saved on this device, but account sync was not confirmed. Retry Save when the connection is available.';
      console.warn('CoreOptimise Health sync push failed',e);
      return false
    }finally{syncing=false;followUp()}
  }
  async function commitProfile(patch){
    if(!syncEndpoint||!signedIn)return {ok:false,localSaved:false,error:'Sign in to save this record to your account.'};
    if(pullConflict)return {ok:false,localSaved:false,error:syncError};
    if(syncing)return {ok:false,localSaved:false,error:'Health sync is in progress. Try Save again when it finishes.'};
    if(!setProfile(patch))return {ok:false,localSaved:false,error:'The record could not be saved on this device.'};
    clearTimeout(syncTimer);syncTimer=0;
    var ok=await push();
    return {ok:ok,localSaved:true,error:ok?'':'Saved on this device, but account sync was not confirmed. Keep this page open and retry Save.'};
  }
  function schedulePush(){
    localRevision++;pendingPush=true;
    if(!syncEndpoint||!signedIn||pullConflict){syncEvent();return;}
    clearTimeout(syncTimer);syncTimer=setTimeout(function(){syncTimer=0;return push();},650);syncEvent()
  }

  function providerUrl(provider,action){
    var base=providerBase||syncEndpoint;
    if(!base)return'';
    var sep=base.indexOf('?')>-1?'&':'?';
    return base+sep+'scope=provider&provider='+encodeURIComponent(provider)+'&action='+encodeURIComponent(action||'start')
  }
  async function createPairingCode(){
    if(!syncEndpoint||!signedIn)return{ok:false,error:'Secure cloud sync must be enabled before pairing a mobile health app.'};
    try{
      var sep=syncEndpoint.indexOf('?')>-1?'&':'?';
      var r=await fetch(syncEndpoint+sep+'scope=mobile&action=create_pairing',{method:'POST',credentials:'include',headers:{Accept:'application/json'}});
      var body=await r.json();
      if(!r.ok)return{ok:false,error:body.error||'Could not create pairing code'};
      return{ok:true,code:body.code,expiresAt:body.expiresAt}
    }catch(e){return{ok:false,error:String(e.message||e)}}
  }

  window.CoreOptimiseHealth={
    version:2,
    get:read,
    definitions:function(){return clone(metricDefs)},
    setProfile:setProfile,
    commitProfile:commitProfile,
    setPermission:setPermission,
    setMetric:setMetric,
    setMetrics:setMetrics,
    removeMetric:removeMetric,
    addBiomarker:addBiomarker,
    removeBiomarker:removeBiomarker,
    clearCategory:clearCategory,
    disconnectSource:disconnectSource,
    clearAllHealthData:clearAllHealthData,
    contextSummary:contextSummary,
    coverage:coverage,
    sourceCount:sourceCount,
    latestUpdated:latestUpdated,
    trend:trend,
    trends:trends,
    saveContextSnapshot:saveContextSnapshot,
    compareContextSnapshots:compareContextSnapshots,
    latestAISummary:latestAISummary,
    requestAISummary:requestAISummary,
    compareAISummaries:compareAISummaries,
    candidateContext:candidateContext,
    setPreferredSource:setPreferredSource,
    preferredSourceFor:preferredSourceFor,
    resolveMetricConflict:resolveMetricConflict,
    metricConflicts:function(){return read().metricConflicts.filter(function(x){return x.status!=='resolved'})},
    exportHealthContext:exportHealthContext,
    feedback:feedback,
    pull:pull,
    push:push,
    syncStatus:syncStatus,
    providerUrl:providerUrl,
    createPairingCode:createPairingCode
  };

  document.dispatchEvent(new CustomEvent('coreoptimise:health-ready',{detail:{api:window.CoreOptimiseHealth}}));
  if(syncEndpoint&&signedIn)setTimeout(pull,120)
})();